export default "__VITE_ASSET__BApQCHtK__"